// lib/selectLayoutComponent.ts
import React, { ReactElement } from "react";
import { Styling, Template, CompanyInfo } from "../../types";
import Footer1 from "./templates/design1/Footer";
import NavBar1 from "./templates/design1/NavBar";
import Footer2 from "./templates/design2/Footer";
import NavBar2 from "./templates/design2/NavBar";
import Footer3 from "./templates/design3/Layout/Footer";
import NavBar3 from "./templates/design3/Layout/NavBar";
interface LayoutComponentProps {
  styling: Styling;
  companyInfo?: CompanyInfo;
}
export type LayoutComponentType = "navbar" | "footer";
export const layoutComponentMap: {
  [key in LayoutComponentType]: {
    [key in Template]: React.FC<LayoutComponentProps>;
  };
} = {
  navbar: {
    design1: NavBar1,
    design2: NavBar2,
    design3: NavBar3,
  },
  footer: {
    design1: Footer1,
    design2: Footer2,
    design3: Footer3,
  },
};

export function selectLayoutComponent(
  type: LayoutComponentType,
  template: Template,
  props: LayoutComponentProps
): ReactElement {
  const components = layoutComponentMap[type];
  const SelectedComponent = components[template] || components["design1"]; // Fallback to design1
  // const SelectedComponent = components[template]; // Fallback to design1
  return <SelectedComponent {...props} />;
}
